import { AuthResponse, SignupData, verifyRequestData, verifyEmailResponse } from 'store/auth/types';
import { apiCall } from '../index';

export const login = (email: string, password: string): Promise<AuthResponse> =>
  apiCall({
    method: 'post',
    url: '/auth/login',
    data: { email, password },
  });

export const changePassword = (email: string, password: string): Promise<null> =>
  apiCall({
    method: 'post',
    url: '/auth/change-password',
    data: { email, password },
  });

export const logout = (id: string): Promise<null> => apiCall({ method: 'post', url: `/auth/logout/${id}` });

export const setNewPassword = (email: string, password: string, session: string): Promise<{ accessToken: string }> =>
  apiCall({ method: 'post', url: '/auth/set-password', data: { email, password, session } });

export const initPasswordReset = (email: string): Promise<null> =>
  apiCall({ method: 'post', url: '/auth/password-reset/init', data: { email } });

export const confirmPasswordReset = (token: string, password: string): Promise<AuthResponse> =>
  apiCall({ method: 'post', url: '/auth/password-reset/confirm', data: { token, password } });

export const requestIntegrationAuth = (appId: string): Promise<string> =>
  apiCall({ method: 'post', url: `auth/login/integration/${appId}/request` });

export const resultIntegrationAuth = (appId: string, body: any): Promise<string> =>
  apiCall({ method: 'post', url: `auth/login/integration/${appId}/result`, data: body });

export const checkEmail = (email: string): Promise<string> =>
  apiCall({ method: 'post', url: '/auth/check-email', data: { email } });

export const checkEmailPendingStatusApi = (params: string): Promise<{ statusCode: number; message: string }> =>
  apiCall({ method: 'get', url: `/user/check-existing-user${params}` });

export const signup = (data: SignupData): Promise<string | null> =>
  apiCall({ method: 'post', url: '/auth/signup', data: data });

export const verifyEmail = (token: verifyRequestData): Promise<verifyEmailResponse> =>
  apiCall({ method: 'post', url: '/auth/verify-email', data: token });

export const resendEmail = (email: string): Promise<string> =>
  apiCall({ method: 'post', url: '/auth/resend', data: { email } });
